/* src/app/ai-sourcing/archive-candidate-modal/archive-candidate-modal.component.scss */
/*# sourceMappingURL=archive-candidate-modal.component-QYHEN6IZ.css.map */
